import { defaultHttpResponse } from "../auth/AuthInterface";

import { PaginacionProps } from "../global/PaginacionInterface";

// Definición de defaults

export const defaultGenerarListaEstrados: GenerarListaEstradosResponse = {
    ...defaultHttpResponse,
    idListaEstrados:        '',
    idEstatus:              0,
}

export const defaultDetalleListaEstrados: DetalleListaEstradosResponse = {
    ...defaultHttpResponse,
    idListaEstrados:        '',
    numeroSeguimiento:      0,
    idEstatus:              0,
    notificacionDetalle:    [],
    listaEstrados:          '',
    listaEstradosFirmado:   '',
}

export const defaultPublicarListaEstrados: PublicarListaEstradosResponse = {
    ...defaultHttpResponse,
    idListaEstrados:        '',
    listaEstrados:          '',
    listaEstradosFirmado:   '',
    notificacionDetalle:    [],
}

export const defaultFinalizarListaEstrados: FinalizarListaEstradosResponse = {
    ...defaultHttpResponse
}

export const defaultBuscarListaEstrados: BuscarListaEstradosResponse = {
    ...defaultHttpResponse,
    records:                [],
    currentPageIndex:       0,
    pageCount:              0,
    recordsCount:           0,
}

// Creación de interfaces

export interface NotificacionDetalleResponse {
    id:                         number;
    referencia:                 string;
    otraReferencia:             string;
    tipoParte:                  string;
    fechaAcuerdo:               string;
    tipoJuicio:                 string;
    tipoAcuerdo:                string;
    subTipoAcuerdo:             string;
    actores:                    string[];
    demandados:                 string[];
    publicar:                   boolean;
    documentoAcuerdoFirmado:    string;
}

export interface GenerarListaEstradosResponse {
    success?:                   boolean;
    message?:                   string;
    idListaEstrados:            string;
    idEstatus:                  number;
}

export interface DetalleListaEstradosResponse {
    success:                    boolean;
    message?:                   string;
    idListaEstrados:            string;
    numeroSeguimiento:          number;
    idEstatus:                  number;
    notificacionDetalle:        NotificacionDetalleResponse[];
    listaEstrados:              string;
    listaEstradosFirmado:       string;
}

export interface PublicarListaEstradosParams {
    idListaEstrados:            string;
    notificaciones:             NotificacionDetalleResponse[];
}

export interface PublicarListaEstradosResponse {
    success:                    boolean;
    message?:                   string;
    idListaEstrados:            string;
    listaEstrados:              string;
    listaEstradosFirmado:       string;
    notificacionDetalle:        NotificacionDetalleResponse[];
}

export interface FinalizarListaEstradosParams {
    idListaEstrados:            string;
}

export interface FinalizarListaEstradosResponse {
    success:                    boolean;
    message:                    string;
}

export interface BuscarListaEstradosParams extends PaginacionProps {
    fechaInicio:                string;
    fechaFin:                   string;
}

export interface ListaEstradosResultado {
    idListaEstrados:            number;
    fechaGeneracion:            string;
    usuarioGenero:              string;
    numeroNotificaciones:       number;
    notificaciones:             NotificacionDetalleResponse[];
    documentoListaEstrados:     string;
    documentoListaEstradosFirmada: string;
}

export interface BuscarListaEstradosResponse {
    success?:                   boolean;
    message?:                   string;
    records:                    ListaEstradosResultado[];
    currentPageIndex:           number;
    pageCount:                  number;
    recordsCount:               number;
}
